import { Controller } from "stimulus";
import $ from 'jquery';

export default class extends Controller {
    connect() {
        let user_id = Number(document.querySelector("#user_id")?.dataset['userId']) || 0;
        let chat_room_id = Number(document.querySelector("#room_id")?.dataset['roomId']) || 0;
        let reciever_id = document.getElementById('room_message_reciever_id')?.value || 0;

        if (location.pathname.includes(`commercial/rooms/${chat_room_id}/show/${reciever_id}`)) {
            let id = parseInt(document.querySelector("#id_receiver").textContent);
            const csrf = document.querySelector('meta[name="csrf-token"]').content;

            let indicator = document.getElementById('user_status');
            let text = document.getElementById('user_status_text');
            let buttons =  document.getElementById('button-action');

            jQuery.ajax({
                type: "GET",
                headers: {'X-CSRF-Token': csrf},
                contentType: "application/x-www-form-urlencoded",
                url: `${location.origin}/${sessionStorage.getItem('locale')}/admin/users/connected_user`,
                data: {id},
                success: function (res){
                    if(res.success){
                        indicator.classList.remove('text-muted');
                        text.innerText = 'Conectado';
                        indicator.classList.add('text-success');
                        buttons.style.display = 'inline';
                    }else{
                        indicator.classList.add('text-muted');
                        text.innerText = 'No conectado';
                        indicator.classList.remove('text-success');
                        buttons.style.display = 'inline';
                    }
                },
                error: function (res){
                }
            })
        }else {
            console.log("Estas en otra url")
        }

    }

    disconnect() {}
}